import React, { useState, useRef, useEffect } from 'react';
import Box from '@mui/material/Box';
import AppBarComponent from './components/AppBar/AppBar';
import ZipCodeInput from './components/ZipCodeInput/ZipCodeInput';
import Config from './Config';
import { Button, Collapse, Divider } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart as faHeartOutline } from '@fortawesome/free-regular-svg-icons';
import ConversationInterface from './components/Conversation/ConversationInterface';
import { Routes, Route } from 'react-router-dom';
import Experiment from './Experiment';
import InventoryPreview from './components/Inventory/InventoryPreview';
import { WiStars } from 'react-icons/wi';
import { ReactComponent as InventoryIcon } from './icons/Car.svg';
import { ReactComponent as LocatorIcon } from './icons/MapPin_WithCar.svg';

function App() {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  
  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  
  const handleMenuClose = (event) => {
    setAnchorEl(null);
  };
  return (
    <div>
      <AppBarComponent 
        anchorEl={anchorEl} 
        open={open} 
        handleMenuClick={handleMenuClick} 
        handleMenuClose={handleMenuClose} 
        />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/experiment" element={<Experiment />} />
      </Routes>
    </div>
  );
}
function Home() {
  const [zipCode, setZipCode] = useState('60692');
  const [searchText, setSearchText] = useState('');
  const [criteria, setCriteria] = useState('');
  const [inventory, setInventory] = useState([]);
  const [messages, setMessages] = useState([]);
  const [hoveringInventory, setHoveringInventory] = useState(false);
  const [hoveringLocator, setHoveringLocator] = useState(false);
  const [isPreviewingInventory, setPreviewingInventory] = useState(false);
  const inventoryEndRef = useRef(null);

  // const handleSearchClick = () => {
  //   setSearch(searchText);
  //   setPerformSearch(true);
  // };

  const handleCriteriaChange = (criteria) => {
    setCriteria(criteria);
  };


  const handleSearchChange = (_event, value) => {
    setSearchText(value);
  };

  // const handleFilterChange = (updatedFilters) => {
  //   setFiltersData(updatedFilters);
  //   // Trigger data updates in searchResults component
  //   console.log('Updated Filters:', updatedFilters);
  // };

  // const handleIntelligentCategoryChange = (category) => {
  //   setIntelligentCategory(category);
  // };

  const toggleInventoryPreview = (open) => (event) => {
    if(event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    if (inventory && inventory.length > 0 && !isPreviewingInventory) {
      setPreviewingInventory(open);
    } else {
      setPreviewingInventory(false);
    }
  };

  const previewCollapseListener = (node) => {
    if (node) {
      node.addEventListener('transitionend', () => {
        if (isPreviewingInventory) {
          inventoryEndRef.current?.scrollIntoView({ behavior: "smooth" });
        }
      });
    }
  }

  const highlightInventoryIcon = () => {
    const icon = document.querySelector('.inventory');
    if (icon) {
      const pulsate = () => {
        icon.style.transition = 'transform 0.5s ease-in-out, fill 0.5s ease-in-out';
        icon.style.transform = 'scale(1.2)';
        icon.style.fill = 'rgba(207, 32, 47, 0.3)';
        setTimeout(() => {
          icon.style.transform = 'scale(1)';
          icon.style.fill = 'rgb(207, 32, 47)';
          icon.style.backgroundColor = 'transparent';
        }, 500);
      };

      for (let i = 0; i < 3; i++) {
        setTimeout(pulsate, i * 1000);
      }
    }
  };

  // const highlightLocatorIcon = () => {
  //   const pin = document.querySelector('.locator-pin');
  //   const car = document.querySelector('.locator-car');

  //   if (pin && car) {
  //     const pulsate = () => {
  //       pin.style.transition = 'transform 0.5s ease-in-out, fill 0.5s ease-in-out';
  //       pin.style.transform = 'scale(1.2)';
  //       pin.style.fill = 'rgba(207, 32, 47, 0.3)';

  //       car.style.transition = 'transform 0.5s ease-in-out';
  //       car.style.transform = 'scale(1.2)';
        
  //       setTimeout(() => {
  //         pin.style.transform = 'scale(1)';
  //         pin.style.fill = 'rgb(207, 32, 47)';
  //         pin.style.backgroundColor = 'transparent';

  //         car.style.transform = 'scale(1)';
  //         car.style.backgroundColor = 'transparent';
  //       }, 500);
  //     };

  //     for (let i = 0; i < 3; i++) {
  //       setTimeout(pulsate, i * 1000);
  //     }
  //   }
  // };
 
  useEffect(() => {
    const icon = document.querySelector('.inventory');
    if ((hoveringInventory && isPreviewingInventory) || (!hoveringInventory && !isPreviewingInventory)) {
      if (icon) {
        icon.style.fill = 'rgb(207, 32, 47)';
      }
    } else if (hoveringInventory && !isPreviewingInventory) {
      if (icon) {
        icon.style.fill = 'white';
      }
    } else {
      if (icon) {
        icon.style.fill = 'white';
      }
    }

  }, [hoveringInventory, isPreviewingInventory]);

  useEffect(() => {
    const pin = document.querySelector('.locator-pin');
    const car = document.querySelector('.locator-car');
    if (hoveringLocator) {
      if (pin) {
        pin.style.fill = 'white';
      }
      if (car) {
        car.style.fill = 'rgb(207, 32, 47)';
      }
    } else {
      if (pin) {
        pin.style.fill = 'rgb(207, 32, 47)';
      }
      if (car) {
        car.style.fill = 'white';
      }
    }

  }, [hoveringLocator]);

  useEffect(() => {
    if (inventory && inventory.length > 0) {
      highlightInventoryIcon();
    }
  }, [inventory]);

  useEffect(() => {
    const icon = document.querySelector('.locator');
    if (icon) {
      icon.style.fill = 'white';
      icon.style.secondaryfill = 'rgb(207, 32, 47)';
    }
  }, []);

  return (
    <div sx={{backgroundColor: 'white'}}>
      <Box sx={{ padding: '10px' }}>
        <ConversationInterface 
            config={Config} 
            searchText={searchText} 
            handleSearchChange={handleSearchChange} 
            zipCode={zipCode} 
            criteria={criteria} 
            handleCriteriaChange={handleCriteriaChange} 
            inventory={inventory}
            sharedMessages={messages}
            broadcastSharedMessages={setMessages}
          />
        <Box sx={{ display: 'flex', flexDirection: 'row', marginTop: '20px', alignItems: 'center',}}>
          <Box sx={{ marginLeft: '20px' }} >
            <ZipCodeInput 
              zipCode={zipCode} 
              setZipCode={setZipCode}
            />
          </Box>
          <Divider orientation='vertical' flexItem sx={{ marginLeft: '20px', marginRight: '20px'}}/>
          <Box sx={{ } }>
            <Button 
              onMouseEnter={() => setHoveringInventory(true)}
              onMouseLeave={() => setHoveringInventory(false)}
              onClick={toggleInventoryPreview(!isPreviewingInventory)}
              sx={{
                fontWeight: 'bold',
                backgroundColor: 'transparent',
                border: 'none',
                cursor: 'pointer',
                '&:hover': {
                  backgroundColor: 'rgb(207, 32, 47)',
                  borderRadius: '4px',
                },
                '&.Mui-selected': {
                  backgroundColor: 'rgb(207, 32, 47)',
                  borderRadius: '4px',
                },
                '&:hover.Mui-selected': {
                  backgroundColor: 'transparent',
                },
              }}
              className={isPreviewingInventory ? 'inventorybutton Mui-selected' : 'inventorybutton'}
              > 
                <InventoryIcon className="inventory" fill={isPreviewingInventory ? 'white': 'rgb(207, 32, 47)'} style={ { fontSize: '28px', verticalAlign: 'middle' }} />
              </Button>
          </Box>
          <Divider orientation='vertical' flexItem sx={{ marginLeft: '20px', marginRight: '20px'}}/>
          <Box sx={{ } }>
            <Button 
              onMouseEnter={() => setHoveringLocator(true)}
              onMouseLeave={() => setHoveringLocator(false)}
              onClick={toggleInventoryPreview(false)}
              sx={{
                fontWeight: 'bold',
                backgroundColor: 'transparent',
                border: 'none',
                cursor: 'pointer',
                '&:hover': {
                  backgroundColor: 'rgb(207, 32, 47)',
                  borderRadius: '4px',
                },
              }}> 
                <LocatorIcon className="locator" style={ { fontSize: '28px', verticalAlign: 'middle' }} />
              </Button>
          </Box>
          <Divider orientation='vertical' flexItem sx={{ marginLeft: '20px', marginRight: 'auto'}}/>
          <Box>
            <Button 
              onClick={() => {
                setInventory([]);
                setMessages([]);
              }}
              sx={{
                color: 'rgb(207, 32, 47)',
                fontWeight: 'bold',
                backgroundColor: 'transparent',
                border: 'none',
                cursor: 'pointer',
                '&:hover': {
                  backgroundColor: 'rgb(207, 32, 47)',
                  color: 'white',
                  borderRadius: '4px',
                },
              }}
            >
              <WiStars style={{ color: 'inherit', fontSize: '28px', verticalAlign: 'middle' }} />Clean Chat
            </Button>
          </Box>
          <Divider orientation='vertical' flexItem sx={{ marginLeft: '20px', marginRight: '20px'}}/>
          <Box>
            <Button 
                onClick={() => {
                  setInventory([]);
                  setMessages([]);
                }}
                sx={{
                  color: 'rgb(207, 32, 47)',
                  fontWeight: 'bold',
                  backgroundColor: 'transparent',
                  border: 'none',
                  cursor: 'pointer',
                  '&:hover': {
                    backgroundColor: 'rgb(207, 32, 47)',
                    color: 'white',
                    borderRadius: '4px',
                  },
                }}
              >
              Save Search
              <FontAwesomeIcon icon={faHeartOutline} style={{ color: 'inherit', marginLeft: 5, verticalAlign: 'top', height: '20px' }} />
            </Button>
          </Box>
        </Box>
      </Box>
      <Divider sx={{boxShadow: 4}} />
      <Box sx={{ backgroundColor: 'white'}}>
        <Collapse in={isPreviewingInventory} timeout="auto" behavior="smooth" addEndListener={previewCollapseListener} > 
          <InventoryPreview config={Config} messages={messages} inventory={inventory} setInventory={setInventory} />
        </Collapse>
      </Box>
      <div id="inventory-content-end" ref={inventoryEndRef} />
    </div>
  );
}

export default App;